import { render, staticRenderFns } from "./VerificationIcon.vue?vue&type=template&id=510f723b&scoped=true&lang=pug&"
import script from "./VerificationIcon.vue?vue&type=script&lang=js&"
export * from "./VerificationIcon.vue?vue&type=script&lang=js&"
import style0 from "./VerificationIcon.vue?vue&type=style&index=0&id=510f723b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510f723b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
